<eo-dropdown
  [id]="id"
  [label]="getLabel()"
  [help]="getHelp()"
  [errors]="getErrors()"
  [tabindex]="getTabIndex()"
  [options]="getOptions()"
  [optionLabel]="getOptionLabel()"
  [optionValue]="getOptionValue()"
  [placeholder]="getPlaceholder()"
  [showClear]="getShowClear()"
  [filter]="hasFilter()"
  [filterBy]="getFilterBy()"
  [filterFields]="getFilterFields()"
  [filterPlaceholder]="getFilterPlaceholder()"
  [loading]="isLoading()"
  [config]="getConfig()"
  appendTo="body"
  (change)="change.emit($event)"
/>
